import React from 'react';
import PropTypes from 'prop-types';

import { Input, FormGroup, Label } from 'reactstrap';

export const IInput = ({
  title,
  nameKey,
  name,
  style = {},

  // UseFull When use Numbers 
  useValue = false,

  value = undefined,
  valid,
  required = true,
  readonly = false,
  type = 'text',
  onChangeHandler,
  onInputHandler,
}: any) => {
  const titleFormat = title.replace(/_/g, ' ').toLowerCase();
  if (!value) {
    if (type === "number") {
      value = 0
    } else {
      value = ""
    }
  }
  return (
    <FormGroup className="form-floating text-capitalize">
      <Input
        style={style}
        valid={valid}
        required={required}
        className="form-control"
        id={title}
        placeholder={name ?? titleFormat.toLowerCase()}
        defaultValue={value}
        {...(useValue ? { value } : {})}
        type={type}
        readOnly={!!readonly}
        onChange={(e: any) => { if (onChangeHandler) onChangeHandler(e, nameKey ? nameKey : title) }}
        onInput={(e: any) => { if (onInputHandler) onInputHandler(e, nameKey ? nameKey : title) }}
      />
      <Label className="text-capitalize fs-5">{name ?? titleFormat}</Label>
    </FormGroup>
  );
};

IInput.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  nameKey: PropTypes.string,
  useValue: PropTypes.bool,
  value: PropTypes.any,
  valid: PropTypes.bool,
  required: PropTypes.bool,
  readonly: PropTypes.bool,
  type: PropTypes.any,
  style: PropTypes.object,
  onChangeHandler: PropTypes.func,
  onInputHandler: PropTypes.func,
};
